// extracted by mini-css-extract-plugin
export default {"Placeholder":"GoogleRedirect_Placeholder__qajW5","content":"GoogleRedirect_content__T4kLN"};